import { combineReducers } from "redux";
import { SIGN_OUT } from "redux/actions/actionTypes";

import app from "./app";
import auth from "./auth";
import deployments from "./deployments";
import pipelines from "./pipelines";

import { status, statusWithIds } from "./status";
import { filesApi } from "./filesApi";

const appReducer = (routerReducer) =>
  combineReducers({
    app,
    auth,
    deployments,
    pipelines,
    status,
    statusWithIds,
    [filesApi.reducerPath]: filesApi.reducer,
    router: routerReducer,
  });

const rootReducer = (routerReducer) => (state, action) => {
  if (action.type === SIGN_OUT) {
    // Keep notifications so they survive the reset.
    state = { app: state?.app };
  }
  return appReducer(routerReducer)(state, action);
};

export default rootReducer;
